import React from "react";
import ButtonV2 from "./Button";
import classess from "../styles/blackButton.module.scss";
import classNames from "classnames";

export const BlackButton = ({ children, onClick, iconSrc, iconAlt, disabled,className,type, externalLink }) => {

  const handleClick = (e) => {
    if (disabled) return;

    if (externalLink) {
      window.open(externalLink, "_blank", "noopener,noreferrer");
    } else if (onClick) {
      onClick(e);
    }
  };

  return (
    <ButtonV2
      onClick={handleClick}
      iconSrc={iconSrc}
      iconAlt={iconAlt}
      disabled={disabled}
      type={type}
      className={classNames("bg-black text-white rounded-lg  hover:bg-neutral-800 active:scale-95 active:bg-neutral-900  disabled:bg-gray-500", classess.blackButton,className)}
    >
      {children}
    </ButtonV2>
  );
};

export default BlackButton;
